<template>
  <SfModal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{ I18n.t('reconciliation_proposal.confirm.manual.accept_title') }}
    </template>

    <template v-if="objReviewed" #messages>
      <SfModalMessage variant="warning">
        <span>
          {{
            I18n.t('reconciliation_proposal.confirm.unreviewed', {
              type: objType,
            })
          }}
        </span>
      </SfModalMessage>
    </template>

    <template #body>
      <div class="center">
        {{
          I18n.t('reconciliation_proposal.confirm.manual.accept', {
            name: objName,
            type: objType,
          })
        }}
      </div>
    </template>

    <template #messages-bottom>
      <BlockProposals
        v-if="showProposalBlocking"
        :workflow-name="workflowName"
        :proposals-blocked="proposalsBlocked"
        @toggle-proposal-blocking="toggleProposalsBlocked"
      />
    </template>

    <template #footer>
      <SfButtonDs @click="closeModal">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
      <SfButtonDs variant="primary" @click="confirm">
        {{ confirmButtonLabel }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import BlockProposals from './block-proposals.vue'
import { SfLog } from '@app/adapters/logger'
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'ConfirmAcceptReconciliationProposalModal',
  components: { SfModal, SfModalMessage, BlockProposals, SfButtonDs },
  data() {
    return {
      showModal: true,
      objName: null,
      objType: null,
      objReviewed: null,
      confirmUrl: null,
      workflowName: null,
      showProposalBlocking: false,
      proposalsBlocked: false,
      workflowId: null,
    }
  },
  computed: {
    confirmButtonLabel() {
      if (!this.showProposalBlocking) {
        return I18n.t('reconciliation_proposal.confirm.accept_changes')
      }

      if (this.proposalsBlocked) {
        return I18n.t(
          'reconciliation_proposal.actions.accept_and_block_further_proposals'
        )
      } else {
        return I18n.t(
          'reconciliation_proposal.actions.accept_and_allow_further_proposals'
        )
      }
    },
  },
  methods: {
    openModal({
      objName,
      objType,
      url,
      objReviewed,
      workflowName,
      showProposalBlocking,
      proposalsBlocked,
      workflowId,
    }) {
      this.showModal = true
      this.objReviewed = objReviewed
      this.objName = objName
      this.objType = objType
      this.confirmUrl = url
      this.workflowName = workflowName
      this.showProposalBlocking = showProposalBlocking
      this.proposalsBlocked = proposalsBlocked
      this.workflowId = workflowId
    },
    toggleProposalsBlocked() {
      this.proposalsBlocked = !this.proposalsBlocked
    },
    closeModal() {
      this.showModal = false
    },
    confirm() {
      const url = this.confirmUrl
      const data = [
        { key: 'block_proposals', value: this.proposalsBlocked },
        { key: 'company_workflow_id', value: this.workflowId },
      ]

      try {
        SFetch.postFormRedirect({
          url,
          method: 'POST',
          authenticityToken: Silverfin.csrfToken(),
          data,
        })
      } catch (e) {
        SfLog.warn('Failed to confirm reconciliation proposal', {
          extra: {
            error: e,
          },
        })
      }
      this.closeModal()
    },
  },
}
</script>
